<div class="overlay-desc" *ngIf="showOverlayMessage">
  <div class="overlay-desc-content">
    <p [innerHTML]="'eos-tv-shop-ii.text.trailer-toast-message' | translate"></p>
  </div>
</div>
<div class="overlay-middle" *ngIf="forwarding || rewinding || pause || playing">
  <div class="overlay-desc-content play" *ngIf="playing"></div>
  <div class="overlay-desc-content pause" *ngIf="pause"></div>
  <div class="overlay-desc-content forwarding" *ngIf="forwarding"></div>
  <div class="overlay-desc-content rewinding" *ngIf="rewinding"></div>
</div>
<div class="overlay-time" *ngIf="showOverlayProgress">
  <span class=""left id="curtimetext">{{curTimeText}}</span>
  <span class="right" id="durtimetext">{{durTimeText}}</span>
  <div class="progress-bar" [ngStyle]="{'width': playedPercentage + '%'}"></div>
</div>

